var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout-page',[_c('div',{staticStyle:{"padding":"10px"}},[_c('router-view'),(this.$route.path.length!=1 || _vm.teral)?_c('div',{attrs:{"id":"vue"}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }